import { strings } from '@constants'
import { Record } from 'immutable'
import NegotiationCardItem from './NegotiationCardItem'

const NegotiationCardRecord = Record({
	items: [],
	quoteType: '',
})

class NegotiationCard extends NegotiationCardRecord {
	constructor({ data, quotes = [], quoteType }) {
		const _items = quotes.map((_ei) => {
			const _product = (data ?? []).find((_d) => _ei.product_name === _d.product_name)

			return new NegotiationCardItem({
				product_name: _ei.product_name,
				original_price: _product?.original_price || (quoteType === strings('x') ? _ei?.ex_price : _ei?.for_price),
				mb_counter_price: _product?.mb_counter_price,
				user_counter_price: _product?.user_counter_price,
				status: _product?.status,
			})
		})

		super({
			items: _items,
			quoteType,
		})
	}

	updateItem(productName, updates) {
		const _updatedItems = this.items.map((_i) => {
			if (_i.get('product_name') === productName) {
				return _i.merge(updates)
			}
			return _i
		})
		return this.merge({ items: _updatedItems })
	}

	isValid(key) {
		return this.items.every((_i) => !_i.error) && this.items.some((_i) => typeof _i[key] === 'number' && _i[key] > 0)
	}
}

export default NegotiationCard
